import styled from 'styled-components'

export const Option = styled.option`
    background: #fff;
`
